import { Panel } from "@flightpath/coreui";
import { IUploaderColumnConfig } from "../../../../../../components/ui/UploaderFlow/types/types";
import { BusinessAreaUploaderModal } from "./BusinessAreaUploaderModal_view";
import { Animations } from "../../../../../../core/util/Animations";

export const BUSINESS_AREA_UPLOADER_MODAL_CONFIG = (columnConfig: IUploaderColumnConfig[], onSubmit: any) => {
  return {
    showClose: true,
    title: null,
    content: <BusinessAreaUploaderModal columnConfig={columnConfig} onSubmit={onSubmit} />,
    componentProps: {
      wrapHeight: "large",
      wrapWidth: "large",
      position: "middle",
      overflow: "scroll",
      className: "m-2 modal__wrapper--medium-large-height"
    },
    panelProps: {
      background: Panel.PanelBackgrounds.BG_LIGHT,
      className: "h-auto min-h-100",
      hasShadow: true
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_UP,
      animateOut: Animations.SLIDE_OUT_DOWN
    }
  };
};
